import { SingleSubjectExtentPage } from './SingleSubjectExtentPage';
export default SingleSubjectExtentPage;
